const templates = {
  'EMPTY_MVS_CSV': [
    ['MVS.001.X'], ['MVS.002.X'], ['MVS.003.X']
  ],
  'EMPTY_VIN_CSV': [
    ['VIN001'], ['VIN002'], ['VIN003']
  ],
  'EMPTY_ZIP_CODES_CSV': [
    ['MARKET001', 'ZIPCODE001'], ['MARKET001', 'ZIPCODE002'], ['MARKET002', 'ZIPCODE003']
  ]
}

export function exportTemplateAsCSV (templateName, fileName) {
  let csvContent = 'data:text/csv;charset=utf-8,'
  csvContent += [
    ...templates[templateName]
  ]
    .join('\n')
    .replace(/(^\[)|(\]$)/gm, '')

  const data = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', fileName)
  link.click()
}

export function exportAsCsv (rows, fileName) {
  let csvContent = 'data:text/csv;charset=utf-8,'
  csvContent += [
    ...rows.map(item => `"${Object.values(item).join('","')}"`)
  ]
    .join('\n')
    .replace(/(^\[)|(\]$)/gm, '')

  const data = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', fileName)
  link.click()
}
